import React, { FC } from 'react'
import { motion } from 'framer-motion'
import { getImage } from '../../../app/utlis/imageConstants'
import DynamicSVG from '../../atoms/DynamicSvg/DynamicSvg'

interface ReliabilityEPDSystemProps {
    epdSystemData: any
}

const ReliabilityEDSSystem: FC<ReliabilityEPDSystemProps> = ({ epdSystemData }) => {
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2
            }
        }
    }

    const itemVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.5,
                ease: "easeOut"
            }
        }
    }

    const circleVariants = {
        hidden: { scale: 0.8, opacity: 0 },
        visible: { 
            scale: 1, 
            opacity: 1,
            transition: {
                duration: 0.4,
                delay: 0.2,
                ease: "easeOut"
            }
        }
    }

    return (
        <motion.div 
            className='grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-12 p-4 md:p-8 lg:p-16 lg:px-36'
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
        >
            {epdSystemData.ReliabilityERPSystemData.map((reliable: any, idx: number) => {
                 let img = getImage(reliable.image ?? "") ?? "";
                return (
                    <motion.div 
                        key={idx}
                        className='bg-blackDark rounded-3xl group'
                        variants={itemVariants}
                        whileHover={{ scale: 1.03, transition: { duration: 0.2 } , background: `linear-gradient(145.33deg, ${reliable.bgColor}24, #1B1B1B 29.24%)`,}}
                    >
                        <div className='bg-darkGreyPrimary flex flex-col items-start justify-center relative overflow-hidden gap-2 rounded-3xl'>
                            <div className='border border-[#FFFFFF0D] p-3 md:p-5 rounded-full -mt-4 -ml-5'>
                                <div className='border border-[#FFFFFF0D] p-6 md:p-8 rounded-full -mt-5 -ml-4'>
                                    <motion.div 
                                        className={`w-16 h-16 md:w-20 md:h-20 rounded-full bg-blackDark group-hover:bg-${reliable.color} text-black flex items-center justify-center font-bold text-xl md:text-2xl`}
                                        variants={circleVariants}
                                        whileHover={{ rotate: [0, 5, -5, 0], transition: { duration: 0.5 } }}
                                    >
                                        {/* <img src={reliable.image} className='w-6 h-6 md:w-8 md:h-8' /> */}
                                        <DynamicSVG size='w-full p-4 md:p-8'>{img}</DynamicSVG>
                                    </motion.div>
                                </div>
                            </div>
                            <motion.div 
                                className='p-4 md:p-6 pt-4'
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                transition={{ delay: 0.3, duration: 0.4 }}
                            >
                                <div className={`text-lg md:text-xl text-start font-semibold mb-1 text-white group-hover:text-${reliable.color}`}>{reliable.title}</div>
                                <div className='text-lightGrey text-xs md:text-sm'>{reliable.subtitle}</div>
                            </motion.div>
                        </div>
                    </motion.div>
                )
            })}
        </motion.div>
    )
}

export default ReliabilityEDSSystem
